import type { HeadlineResponseOrganizationResponseRelatedPagedData } from '@on3/api';
import { adjustColorForReadability } from '@on3/ui-lib/utils/accessibility/color';
import { ArticleFeed } from 'components/Headlines/ArticleFeed/ArticleFeed';
import { TextLink } from 'components/UI/Link/TextLink';
import { useRouter } from 'next/router';

import styles from './HighSchoolNewsModule.module.scss';

interface IHighSchoolNewsModuleProps {
  highSchoolArticles: HeadlineResponseOrganizationResponseRelatedPagedData;
}

export const HighSchoolNewsModule = ({
  highSchoolArticles,
}: IHighSchoolNewsModuleProps) => {
  const { list, relatedModel } = highSchoolArticles;
  const router = useRouter();
  const viewAllRoute = `/high-school/${router.query.id}/news/`;
  const viewAllrecruitArticles = list && list?.length >= 6;
  const showNews = !!list?.length;
  const primaryColor = adjustColorForReadability(
    relatedModel?.primaryColor || '#fe3b1f',
  );
  const title = `${relatedModel?.fullName ?? ''} News`;

  return (
    <section className={styles.block}>
      <h2>{title}</h2>

      {showNews && (
        <>
          <ul className={styles.list}>
            {list
              ?.slice(0, 5)
              .map((item) => (
                <ArticleFeed
                  {...item}
                  key={item.key}
                  primaryColor={primaryColor}
                />
              ))}
          </ul>
          {viewAllrecruitArticles && (
            <div>
              <TextLink
                className={styles.btnViewAll}
                href={viewAllRoute}
                style={{ color: primaryColor }}
              >
                View All
              </TextLink>
            </div>
          )}
        </>
      )}
      {!showNews && <span>No News</span>}
    </section>
  );
};
